import React from 'react'
import type { UserSelectProps } from '@ztechapps/webui.input'
import { getCollaboratorUsersDataLoadOptions, UserSelect } from '@ztechapps/webui.input'

export type AssigneeSelectProps = UserSelectProps

// Internal-only assignee picker, shared by the details panel and the batch-assign modal. Reuses
// `MembersSelect`'s `getCollaboratorUsers` data-load options — the server already scopes the
// result to the tenant's collaborator companies, so this never filters on the client. A caller
// `filter` merges into the query filter rather than being dropped.
export const AssigneeSelect = ({ filter, ...props }: AssigneeSelectProps) => (
  <UserSelect {...props} filter={filter} dataLoadOptions={getCollaboratorUsersDataLoadOptions(filter)} />
)
